import React from 'react';
import Modal from './Modal';
import { FaTrash, FaExclamationTriangle, FaCheck, FaTimes } from 'react-icons/fa';

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirmar acción',
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  type = 'danger', // 'danger', 'warning', 'info'
  isLoading = false,
  size = 'small'
}) => {
  const getIcon = () => {
    switch (type) {
      case 'danger':
        return <FaTrash />;
      case 'warning':
        return <FaExclamationTriangle />;
      default:
        return <FaCheck />;
    }
  };

  const getButtonClass = () => {
    switch (type) {
      case 'danger':
        return 'modal-btn-danger';
      case 'warning':
        return 'modal-btn-warning';
      default:
        return 'modal-btn-primary';
    }
  };

  const handleConfirm = () => {
    if (onConfirm && !isLoading) {
      onConfirm();
    }
  };

  const footer = (
    <>
      <button
        type="button"
        className="modal-btn modal-btn-secondary"
        onClick={onClose}
        disabled={isLoading}
      >
        <FaTimes /> {cancelLabel}
      </button>
      <button
        type="button"
        className={`modal-btn ${getButtonClass()}`}
        onClick={handleConfirm}
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <div className="spinner"></div>
            Procesando...
          </>
        ) : (
          <>
            {getIcon()} {confirmLabel}
          </>
        )}
      </button>
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size={size}
      footer={footer}
      closeOnOutsideClick={!isLoading}
      showCloseButton={!isLoading}
    >
      <div className="confirm-modal-content">
        <p>{message}</p>
      </div>
    </Modal>
  );
};

export default ConfirmModal;